import { render, staticRenderFns } from "./FourOFour.vue?vue&type=template&id=15220463&scoped=true"
import script from "./FourOFour.vue?vue&type=script&lang=ts"
export * from "./FourOFour.vue?vue&type=script&lang=ts"
import style0 from "./FourOFour.vue?vue&type=style&index=0&id=15220463&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15220463",
  null
  
)

export default component.exports